import {
  TypographyVariantsOptions,
  TypographyVariants,
} from '@mui/material/styles';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@fontsource/poppins/300';
import '@fontsource/poppins/400';
import '@fontsource/poppins/500';
import '@fontsource/poppins/700';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    display1: React.CSSProperties;
    display2: React.CSSProperties;
    display3: React.CSSProperties;

    label1: React.CSSProperties;
    label2: React.CSSProperties;
    label3: React.CSSProperties;

    body1: React.CSSProperties;
    body2: React.CSSProperties;
    body3: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    display1?: React.CSSProperties;
    display2?: React.CSSProperties;
    display3?: React.CSSProperties;

    label1?: React.CSSProperties;
    label2?: React.CSSProperties;
    label3?: React.CSSProperties;

    body1?: React.CSSProperties;
    body2?: React.CSSProperties;
    body3?: React.CSSProperties;
  }

  // interface TypographyOptions {
  //   variants: keyof TypographyVariantsOptions;
  // }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    // Headline variants
    h1: true;
    h2: true;
    h3: true;
    h4: true;
    h5: true;
    h6: true;

    // Display variants
    display1: true;
    display2: true;
    display3: true;

    // Label variants
    label1: true;
    label2: true;
    label3: true;

    // Body variants
    body1: true;
    body2: true;
    body3: true;
  }
}

function createVariant(
  name: keyof TypographyVariants,
  fontSize: number,
  lineHeightPx: number,
  fontWeight = 400,
): TypographyVariantsOptions {
  return {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    [name]: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight,
      fontSize: `${fontSize / 16}rem`,
      lineHeight: lineHeightPx / fontSize,
    },
  };
}

export const typography: TypographyVariantsOptions = {
  // Display variants
  ...createVariant('display1', 57, 64),
  ...createVariant('display2', 42, 52),
  ...createVariant('display3', 36, 44),

  // Headline variants
  ...createVariant('h1', 32, 40),
  ...createVariant('h2', 28, 36),
  ...createVariant('h3', 24, 32),

  // Title variants
  ...createVariant('h4', 22, 28),
  ...createVariant('h5', 16, 24, 500),
  ...createVariant('h6', 14, 20, 500),

  // Label variants
  ...createVariant('label1', 14, 20, 500),
  ...createVariant('label2', 12, 16, 500),
  ...createVariant('label3', 11, 16, 500),

  // Body variants
  ...createVariant('body1', 16, 24),
  ...createVariant('body2', 14, 20),
  ...createVariant('body3', 12, 16),
};
